<template>
  <multi-selection-tool-button
    icon="mdi-file-delimited"
    :disabled="disabled"
    :tooltip="$t('ExportToCSV')"
    @click="$emit('click')"
  />
</template>

<script>
import MultiSelectionToolButton from "@/components/Home/Forms/_Atoms/TableToolbarButton";

export default {
  name: "HomeFormTableExportToCsvTool",

  components: { MultiSelectionToolButton },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    dataToExport: Array,

    fileName: String
  },

  watch: {
    dataToExport(newDataSet) {
      if (newDataSet) {
        this.exportCSVFile();
      }
    }
  },

  methods: {
    convertToCSV(objectArray) {
      let csvContent = "";
      for (const object of objectArray) {
        csvContent += this.getCsvLine(object);
      }
      return csvContent;
    },

    getCsvLine(object) {
      let line = [];
      for (const value of Object.values(object)) {
        let cleanValue = this.getCleanValue(value);
        line.push('"' + cleanValue + '"');
      }
      line = line.join(";");
      return line + "\r\n";
    },

    getCleanValue(value) {
      let cleanValue = value;
      if (typeof value === "string") {
        if (value.includes('"')) {
          cleanValue = value.replace('"', "'");
        }
        if (value.includes(";")) {
          cleanValue = value.replace(";", ",");
        }
      }
      return cleanValue;
    },

    exportCSVFile() {
      const csv = this.convertToCSV(this.dataToExport);

      const exportedFileName = this.getExportFileName();

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFileName);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportedFileName);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
      this.$emit("reset-exportation-data");
    },

    getExportFileName() {
      let fileName = this.fileName ? this.fileName : "export";
      let timestamp = this.getTimestamp();
      return fileName + "_" + timestamp + ".csv";
    },

    getTimestamp() {
      const today = new Date();

      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();

      const time =
        today.getHours() + "-" + today.getMinutes() + "-" + today.getSeconds();

      return date + "T" + time;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/TableToolbarButtons/ExportToCSV.vue